<div class="image-viewer">
    <div (click)="dialogRef.close()" class="close" matTooltipPosition="after">
        <i class="fa fa-times"></i>
    </div>
    <swiper-container navigation="true" zoom="true" loop="true">
        @for (ttm of ttms; track ttm) {
            <swiper-slide>
                <div class="swiper-zoom-container" app-svg-as-img [ttm]="ttm">

                </div>
            </swiper-slide>
        }
    </swiper-container>
</div>
